import { createReducer, on } from '@ngrx/store';

import * as RouterActions from './router.actions';
import type { AppRouterState } from './router.state';

export const initialAppRouterState: AppRouterState = {
  vehicleLengthPageVisited: false,
  preconfigPageVisited: false
};

export const routerReducer = createReducer(
  initialAppRouterState,
  on(
    RouterActions.routerResolveEndAction,
    (state, action): AppRouterState => ({
      ...state,
      previousRouteState: state.routeState,
      routeState: action.routeState
    })
  ),
  on(
    RouterActions.storeLocationAndBaseHrefAction,
    (state, action): AppRouterState => ({
      ...state,
      location: action.location,
      baseHref: action.baseHref
    })
  ),
  on(
    RouterActions.storeVehicleLengthPageVisitedAction,
    (state, action): AppRouterState => ({
      ...state,
      vehicleLengthPageVisited: action.visited
    })
  ),
  on(
    RouterActions.storePreconfigPageVisitedAction,
    (state, action): AppRouterState => ({
      ...state,
      preconfigPageVisited: action.visited
    })
  )
);
